import React from 'react';

import './stylings/SectionTitle.css';


export default function SectionTitle(props) {
	return (
		<div className="section-title">
			<h2 className="font-montserrat-reg">{props.title}</h2>
			<p className="font-opensans-reg">{props.subTitle}</p>
		</div>
	);
}


// WEBPACK FOOTER //
// ./src/components/SectionTitle.js